import { render, staticRenderFns } from "./ArticlePriceInfoDialog.vue?vue&type=template&id=ac304966"
import script from "./ArticlePriceInfoDialog.vue?vue&type=script&lang=ts"
export * from "./ArticlePriceInfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports